<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-history"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <label class="font-weight-bold">{{ "LABEL.INFORMATION-TYPE" | translate }}:</label>
        <select class="form-control ml-1 mr-3 mb-2"
                [(ngModel)]="balanceType"
                (change)="reloadBalanceInfo()">
          <option *ngFor="let balanceType of balanceTypes"
                  [ngValue]="balanceType.id">{{balanceType.name | translate}}</option>
        </select>
      </div>
    </div>
    <!--    First table-->
    <div class="table-responsive">
      <table class="table-sm table-bordered" *ngIf="headSelected">
        <thead class="custom-font-size-table-header">
        <tr class="text-center">
          <th scope="col" title="#"></th>
          <th scope="col" title="{{'TABLE.HEADER.TYPE' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.DATE' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.TO' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.QUANTITY-ASSIGNED' | translate }} {{coin}}"></th>
          <th scope="col" title="Total {{coin}}"></th>
        </tr>
        </thead>
        <tbody class="text-center">
        <tr *ngFor="let historicalbalanceallocation of historicalbalanceallocations; let index = index">
          <td title="#" class="font-weight-bold">{{(page.number * pageNumber) + index + 1}}</td>
          <td title="{{'TABLE.HEADER.TYPE' | translate }}">
          <span class="badge {{classBadge(historicalbalanceallocation)}}">
            {{descriptionAssignmentType(historicalbalanceallocation, index) | translate}}
          </span>
          </td>
          <td
            title="{{'TABLE.HEADER.DATE' | translate }}">{{historicalbalanceallocation.createAt | datetimeformat}}</td>
          <td title="{{'TABLE.HEADER.TO' | translate }}">
            {{enterpriseName(historicalbalanceallocation)}}
          </td>
          <td title="{{'TABLE.HEADER.QUANTITY-ASSIGNED' | translate }}">
            {{symbol(historicalbalanceallocation) + historicalbalanceallocation.quantity.toFixed(4)}}
          </td>
          <td title="Total"> {{historicalbalanceallocation.balance.toFixed(4)}}</td>
        </tr>
        </tbody>
      </table>
      <!--    Second table-->
      <table class="table-sm table-bordered" *ngIf="!headSelected">
        <thead class="custom-font-size-table-header">
        <tr class="text-center">
          <th scope="col" title="#"></th>
          <th scope="col" title="{{'TABLE.HEADER.DATE' | translate }}"></th>
          <th scope="col" title="{{ 'TABLE.HEADER.SUBJECT' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.TYPE' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.PRICE' | translate }} {{coin}}"></th>
          <th scope="col" title="{{'TABLE.HEADER.BALANCE' | translate }} {{coin}}"></th>
        </tr>
        </thead>
        <tbody class="text-center">
        <tr *ngFor="let detailbalanceallocation of detailbalanceallocations; let index = index">
          <td title="#" class="font-weight-bold">{{(page.number * pageNumber) + index + 1}}</td>
          <td title="{{'TABLE.HEADER.DATE' | translate }}">{{detailbalanceallocation.createAt | datetimeformat}}</td>
          <td
            title="{{ 'TABLE.HEADER.SUBJECT' | translate }}">{{subjectDocument(detailbalanceallocation)}}</td>
          <td title="{{'TABLE.HEADER.TYPE' | translate }}">{{serviceweight(detailbalanceallocation)}}</td>
          <td
            title="{{'TABLE.HEADER.PRICE' | translate }} {{coin}}">{{detailbalanceallocation.weight.toFixed(4)}}        </td>
          <td
            title="{{'TABLE.HEADER.BALANCE' | translate }} {{coin}}">{{detailbalanceallocation.actualBalance.toFixed(4)}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <nav class="Page navigation pagination-custom">
      <div class="row">
        <div class="col-md-8 mt-1">
          <div class="justify-content-row">
            <span class="mr-1 font-weight-normal">Mostrar </span>
            <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                    (ngModelChange)="loadBalanceallocations(enumPage.First)">
              <option *ngFor="let page of pageNumbers" [value]="page.value"
                      class="font-weight-bold">{{page.value}}</option>
            </select>
            <span class="font-weight-normal"> registros.</span>
          </div>
          <div class="page-total-entries">
            {{ "LABEL.TOTAL-RECORDS" | translate }}
            : {{historicalbalanceallocations.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
          </div>
        </div>
        <div class="col-md-4">
          <ul class="pagination justify-content-end text-center">
            <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
              <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadBalanceallocations(enumPage.First)"
                 tabindex="-1" aria-disabled="true">
                <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
                {{ "BUTTON.FIRST" | translate }}
              </a>
            </li>
            <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
              <a class="left {{page.number == 0 ? 'disabled' : ''}}"
                 (click)="loadBalanceallocations(enumPage.Previous)">
                <i class="fa fa-angle-left" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
              <a class="right" (click)="loadBalanceallocations(enumPage.Next)"><i
                class="fa fa-angle-right" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
              <a class="next" (click)="loadBalanceallocations(enumPage.Last)">
                {{ "BUTTON.LAST" | translate }}
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  <div class="modal-footer">
    <div class="row justify-content-end text-right">
      <button type="button" class="btn btn-outline-success"
              (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}</button>
    </div>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
